// extracted by css-extract-rspack-plugin
export default {"disabledInput":"disabledInput-ZzsrN9"};